// AB#17128 AC12: one severity scale shared by every Compliance Center surface; colorblind-safe (text + shape, not color alone); green never surfaced
export const SEVERITY_TOKENS = {
    hit: { label: 'Hit', background: '#FDECEA', border: '#B3261E', text: '#8C1D18', marker: '●' },
    late: { label: 'Late', background: '#FFF1E0', border: '#B45F06', text: '#7A4100', marker: '◆' },
    near: { label: 'Near', background: '#FFF4D6', border: '#A16207', text: '#713F12', marker: '▲' },
    low: { label: 'Low', background: '#FEFBE8', border: '#A16207', text: '#713F12', marker: '○' },
};

// 3-tier clock surfaces render Near in yellow; 4-tier rate surfaces render Near in orange (Spec §3.4)
export const toneFor = (statusTone, kind) => {
    if (statusTone === 'near' && (kind === 'leakRate' || kind === 'chronicLeak')) {
        return { ...SEVERITY_TOKENS.near, background: '#FFE8D6', border: '#C2410C', text: '#7C2D12' };
    }
    return SEVERITY_TOKENS[statusTone] || null;
};
